import Swiper from 'swiper/bundle'

export default function TestimonialSlider () {
  const WRAPPERS = document.querySelectorAll('.mtt-testimonials')

  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = WRAPPERS[i]
      const SWIPER_CONTAINER = WRAPPER.querySelector('.swiper-container')
      const PAGINATION = WRAPPER.querySelector('.swiper-pagination')

      const SWIPER = new Swiper(SWIPER_CONTAINER, {
        init: false,
        slidesPerView: 1,
        speed: 800,
        spaceBetween: 24,
        watchOverflow: true,
        allowTouchMove: false,
        autoHeight: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: PAGINATION,
          type: 'bullets',
          clickable: true
        },
        breakpoints: {
          961: {
            autoHeight: false
          }
        }
      })

      SWIPER.init()
    }
  }
}
